<template>
	<div class="quick-tagger">
		<tag-input v-model="currentTags" :src="$attrs['src']" :placeholder="labels['placeholder']"> </tag-input>
	</div>
</template>

<script>
import { TagInput } from 'vue-bootstrap';
import tectoastr from '@/lib/tectoastr';

/**
 * The QuickTagger component.
 */
export default {
	components: {
		TagInput,
	},
	props: {
		tags: {
			type: [Array, String],
			default: () => [],
		},
		url: {
			type: String,
			required: true,
		},
		labels: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			currentTags: this.tags,
		};
	},
	watch: {
		currentTags() {
			this.$http
				.post(this.url, {
					tags: this.currentTags,
				})
				.then(
					() => {},
					(error) => {
						tectoastr.error(error.response.data.message || document.getElementById('alerts-generic').innerHTML);
					}
				);
		},
	},
};
</script>
